export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || "id",
        parentId: parentId || "parentId",
        childrenList: children || "children"
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}

const baseURL = process.env.VUE_APP_BASE_API;
// 文件流
export function download(fileName, isDelete = false) {
    window.location.href =
        baseURL +
        "/common/download?fileName=" +
        encodeURI(fileName) +
        "&delete=" +
        isDelete;
}



export function downloadFile(url, fileName) {
    let blob = new Blob([url], { type: "application/msword" }); // res就是接口返回的文件流了
    let objectUrl = URL.createObjectURL(blob);
    let link = document.createElement('a')
    link.download = fileName
    link.href = objectUrl
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href)
}

import JSZip from "jszip";
import FileSaver from "file-saver";
import axios from 'axios'
const getFile = url => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url,
            responseType: 'arraybuffer'
        }).then(data => {
            resolve(data.data)
        }).catch(error => {})

    })
}
export function handleBatchDownload(data, fileName) {
    var newUrl = data.split(',')
    const zip = new JSZip()
    const cache = {}
    const promises = []
    newUrl.forEach(item => {
        const promise = getFile(item).then(data => { // 下载文件, 并存成ArrayBuffer对象
            const arr_name = item.split("/")
            const file_name = arr_name[arr_name.length - 1] // 获取文件名
            zip.file(file_name, data, { binary: true }) // 逐个添加文件
            cache[file_name] = data
        })
        promises.push(promise)
    })

    Promise.all(promises).then(() => {
        zip.generateAsync({ type: "blob" }).then(content => { // 生成二进制流
            FileSaver.saveAs(content, fileName) // 利用file-saver保存文件
        })
    })

}


// WEBPACK FOOTER //
// ./src/utils/comm.js